import t1 from "../images/t1.svg";
import t2 from "../images/t2.svg";
import t3 from "../images/t3.svg";
import t4 from "../images/t4.svg";
import t5 from "../images/t5.svg";

export const data = [
  {
    image: {
      src: t2,
      w: 40,
      h: 40,
    },
    title: "Android Jetpack libraries",
    text: "DataBinding, Hilt, Lifecycle, Navigation, MaterialDesign",
  },
  {
    image: {
      src: t1,
      w: 28,
      h: 28,
    },
    title: "Kotlin",
    text: "Application developed",
  },
  {
    image: {
      src: t4,
      w: 40,
      h: 40,
    },
    title: "Google billing",
    text: "Play Market subscription",
  },
  {
    image: {
      src: t5,
      w: 36,
      h: 36,
    },
    title: "ExoPlayer",
    text: "Video playing",
  },
  {
    image: {
      src: t3,
      w: 36,
      h: 36,
    },
    title: "Firebase",
    text: "Authentication, Crashlytics, Analytics, Remote Config, A/B testing, Notifications",
  },
];
